import logo from './logo.svg';
import './App.css';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import Alert from '@mui/material/Alert';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import { useState, useCallback } from "react";
import LoadingButton from '@mui/lab/LoadingButton';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import axios from "axios";

function App() {

    const [text, setText] = useState("");
    const [loading, setLoading] = useState(false);
	const [label, setLabel] = useState(null);
	const [score, setScore] = useState(null);
    const [error, setError] = useState(null);

    const process = useCallback(() => {
		setLoading(true);
		
        /*
		setTimeout(() => {
			var result = {
				label: "neutral",
				score: 0.5
			};
            
            //Normal case
			setLabel(result.label);
			setScore(result.score);
            setError(false);

            //Error case
            //setLabel(null);
			//setScore(null);
            //setError(true);

			setLoading(false);
		}, 500);*/

		
		axios.post("https://api.artintellab.com/free/asa/infer", {
            text: text
        })
		.then((result) => {
			setLabel(result.data.label);
			setScore(result.data.score.toFixed(2));
            setError(false);
            setLoading(false);
		}).catch((error) => {
			setLabel(null);
			setScore(null);
            setError(true);
            setLoading(false);
		});
	});

    return (
        <div className="App">
            <Box sx={{ flexGrow: 1, p: 2}}>
                <Grid container rowSpacing={1} columnSpacing={3}>
                    <Grid item sm={6} xs={12}>
                        <Grid container rowSpacing={1} columnSpacing={3}>
                            <Grid item xs={12}>
                                <TextField
                                    id="outlined-multiline-flexible"
                                    label="Arabic Text"
                                    sx={{
                                        width: '100%'
                                    }}
                                    multiline
                                    rows={10}
                                    value={text}
                                    onChange={(e) => setText(e.target.value)}/>
                            </Grid>
                            <Grid item xs={12}>
                                <LoadingButton
                                    loading={loading}
                                    color="primary"
                                    variant="contained"
                                    sx={{
                                        width: '100%'
                                    }}
                                    onClick={process}
                                >
                                    Process
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item sm={6} xs={12}>
                        <Card>
                            <CardContent>
                                <Typography gutterBottom variant="h4" component="div">
                                    Result
                                </Typography>
                                <Typography component={'span'} variant="body2" color="text.secondary">
                                    {loading === true ?
                                        <span>Processing ...</span>:
                                    error == null ?
                                        <span>Please type an Arabic text and click on "process"...</span>:
                                    error == true ?
                                        <Alert variant="outlined" severity="error">
                                            Server Error, we are working on resolving it ... 
                                        </Alert> :
                                    label == "positive" ?
                                    <Stack spacing={1} alignItems="center" >
                                        <Chip label={"score:" + score} color="primary" />
                                        <SentimentSatisfiedAltIcon color="success" sx={{ fontSize: 100 }}/>
                                    </Stack> :
                                    label == "negative" ?
                                    <Stack spacing={1} alignItems="center" >
                                        <Chip label={"score:" + score} color="primary" />
                                        <SentimentVeryDissatisfiedIcon color="error" sx={{ fontSize: 100 }}/>
                                    </Stack> :
                                    label == "neutral" ?
                                    <Stack spacing={1} alignItems="center" >
                                        <Chip label={"score:" + score} color="primary" />
                                        <SentimentNeutralIcon sx={{ fontSize: 100 }}/>
                                    </Stack> : ""
                                    }    
                                </Typography>
                            </CardContent>
					    </Card>
                    </Grid>  
                </Grid> 
            </Box>
    </div>
  );
}

export default App;
